import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';


import { HttpClient } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { User } from 'app/core/user/user.model';

import { UserService as UserServiceObservable } from 'app/core/user/user.service';
import { Router } from '@angular/router';
import { NavigationService } from '../navigation.service';



@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: User;


    constructor(
        private _httpClient: HttpClient,
        private _userServiceObservable: UserServiceObservable,
        private _router: Router,
        private _navigationService: NavigationService
    ){}

    user( userID: number, rol: string ): Observable<any> {

        if (this._user) {
            return of( this._user );
        }

        return this._httpClient.get(`api/user-nutritionis/${ userID }/detail-min` )
        .pipe(
            switchMap(( usuario: any ) => {

                const mUsuario: User = {
                    id: usuario['id'],
                    name: `${ usuario['first_name'] || ' '} ${ usuario['last_name'] || '' } `,
                    email: usuario['email'],
                    rol: usuario['role__clv'],
                    roldes: usuario['role__description'],
                    rolId: usuario['role_id'],
                    avatarId: usuario['avatar_id'],
                    bgId: usuario['bg_id'],
                    logoId: usuario['logo_id'],
                    dateExpires:  usuario['date_expires'],
                    dateExpiresfinal: usuario['date_expiresfinal'],
                    paymentType: usuario['payment_type'],
                };

                // this._navigationService.registerHandlers(usuario['role__clv']);

                this._userServiceObservable.user = mUsuario;
                this._user = mUsuario;
                return of( mUsuario );

            }),
            catchError(_ => {
                return of('no more requests!!!');
            })

        );
    }


    clearUser(): void {
        this._user = null;
    }


    userDetail(): User {
        return this._user;

    }

}
